export const errorMessage = 'Failed to purchase variation via logo editor perseus';
